import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import DateInput from 'components/DateInput';
import Field from 'components/Field';
import styles from './FromToBeResumedDateFilter.module.scss';

function FromToBeResumedDateFilter() {
  const dispatch = useDispatch();
  const { fromToBeResumedDate } = useSelector(currentFiltersSelector);

  const handleOnChange = useCallback(
    (date) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.fromToBeResumedDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="To Be Resume Date (From)"
      labelClassName="h5"
    >
      <DateInput
        className={styles.dateInput}
        value={fromToBeResumedDate}
        onChange={handleOnChange}
        placement="top"
      />
    </Field>
  );
}

export default FromToBeResumedDateFilter;
